import * as PIXI from 'pixi.js'

export class Debug {
  constructor() {
    this.disabled = false;
    this.app = null;
    this.r1 = null;
    this.r2 = null;
    this.r3 = null;
    this.r4 = null;
    this.r5 = null;
    this.r6 = null;
    this.r7 = null;
    this.shipsContainer = null;
  }
  init(app, shipsContainer) {
    if(this.disabled) { return }
    this.app = app;
    this.shipsContainer = shipsContainer.getBounds();
    this.generate(['0xF39C12', '0x2ECC71', '0x2ECCFF', '0x16A085', '0xF1C40F', '0xE74C3C', '0x8E44AD']);
    setTimeout(() => {
      this.app.stage.addChild(
        this.r1, this.r2, this.r3, this.r4, this.r5, this.r6, this.r7
      );
    }, 1000);
  }
  ticker(th) {
    if(this.disabled) { return }
    // console.log(Math.round(th.bgElContainer.getBounds().y), Math.round(th.bgElContainer.y));
    // this.update('r1', 100, th.refuellerContainer.x, 5);
    // this.update('r1', th.bgElContainer.children[0].getBounds().y, 5);
    // this.update('r2', th.bgElContainer.children[1].getBounds().y, 5);
    // this.update('r3', th.bgElContainer.children[2].getBounds().y, 5);
    // this.update('r4', th.bgElContainer.children[3].getBounds().y + th.bgElContainer.children[3].height + 100, 5);
    // this.update('r5', th.bgElContainer.children[3].getBounds().y - 50, 5);
    // this.update('r5', th.bgElContainer.children[4].getBounds().y, 5);
    // this.update('r6', th.bgElContainer.children[5].getBounds().y, 5);
    // this.update('r1', th.shipsContainer.getBounds().y, 5);
    // this.update('r2', th.shipsContainer.getBounds().y + (th.shipsContainer.getBounds().height / 7) * 1, 5);
    // this.update('r3', th.shipsContainer.getBounds().y + (th.shipsContainer.getBounds().height / 7) * 2, 5);
    // this.update('r4', th.shipsContainer.getBounds().y + (th.shipsContainer.getBounds().height / 7) * 3, 5);
    // this.update('r5', th.shipsContainer.getBounds().y + (th.shipsContainer.getBounds().height / 7) * 4, 5);
    // this.update('r6', th.shipsContainer.getBounds().y + (th.shipsContainer.getBounds().height / 7) * 5, 5);
    // this.update('r7', th.shipsContainer.getBounds().y + (th.shipsContainer.getBounds().height / 7) * 6, 5);
  }
  generate(colors) {
    for (let i = 1; i <= colors.length; i++) {
      this[`r${i}`] = new PIXI.Graphics();
      this[`r${i}`].beginFill(colors[i-1]);
      this[`r${i}`].drawRect(0, 0, 2000, 1);
      this[`r${i}`].x = 0;
      this[`r${i}`].endFill();
      // this[`r${i}`].alpha = 0.2;
    }
  }
  update(name, y, x, height) {
    this[name].y = y
    this[name].x = x
    this[name].width = 100
    this[name].height = height
  }
}
